export const INITIAL_EVENTS = [
  {
      id: "kfdw4",
      title: "Do work",
      start: "24-02-2021T23:04:12",
      end: "24-02-2021T23:04:12"
  },
  {
      id: "ko5qwoax",
      title: "Heyy",
      start: "2021-05-13",
      end: "2021-05-14"
  },
  {
      id: "ko5qx9ec",
      title: "do dsa",
      start: "2021-05-01T12:00:00+04:00",
      end: "2021-05-01T12:30:00+04:00"
  },
  {
      id: "ko5r86x5",
      title: "Helloo sir",
      start: "2021-05-12",
      end: "2021-05-13"
  },
  {
      id: "ko5tber1",
      title: "aSD",
      start: "2021-05-11",
      end: "2021-05-12"
  },
  {
      id: "ko5tbguj",
      title: "SDASDSA",
      start: "2021-05-12",
      end: "2021-05-13"
  }
]